const states = {
  tryVuex: 'Estado de prueba vuex...',
  contracts: [],
  unassignedProjects: [],
  paginateUnassignedProjects: null,
  assignments: [],
  paginateAssignments: null,
  projectId: null,
  assignmentId: null,
  project: null,
  assignment: null,
  selects: [],
  projects: [],
  taskValidations: [],
  assignmentTypes: [],
  taskValidation: {
    id: null,
    assignment_type_id: null,
    event_type: null,
    name: null
  },
  typeEvents: null,
  laboral_reference: {}
}
export default states;
